import { useIsAuthenticated } from "@azure/msal-react";
import { Button } from "@mui/material";
import { filterButtonStyles } from "components/templates/dataGridTable/Toolbars/CustomToolbar";
import { certicateUploadProcessTypeAtom } from "pages/UploadCertificate/state/uploadCertificateStateBase";
import { CerticateUploadProcessType } from "pages/UploadCertificate/types";
import useCertificateReplacement from "pages/UploadCertificate/hooks/useCertificateReplacement";
import React from "react";
import { useSetRecoilState } from "recoil";
import translations from "translations";
import CerticateUploadProcesSelection from "pages/UploadCertificate/CerticateUploadProcesSelection";
interface Props {}

const UploadCertificateButton: React.FC<Props> = () => {
  const setCerticateUploadProcess = useSetRecoilState(certicateUploadProcessTypeAtom);
  const { resetReplacement } = useCertificateReplacement();
  const isUserLoggedIn = useIsAuthenticated();
  const goToCertificateUpload = () => {
    resetReplacement();
    setCerticateUploadProcess(CerticateUploadProcessType.toDecide);
  };

  return (
    <>
      {isUserLoggedIn && (
        <>
          <Button onClick={goToCertificateUpload} variant="contained" sx={() => filterButtonStyles()}>
            {translations.pages.certificateUpload.label}
          </Button>
          <CerticateUploadProcesSelection />
        </>
      )}
    </>
  );
};

export default UploadCertificateButton;
